import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";

export type ToolTipHandle = {
  show: (timeout?: number) => void;
};

export const ToolTip = forwardRef<ToolTipHandle>((_, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    show: (timeout = 5000) => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), timeout);
    },
  }));

  if (!isVisible) return null;

  return (
    <span className="absolute -top-10 left-1/2 flex max-w-[400px] -translate-x-1/2 flex-col items-start justify-center rounded-lg bg-surface-inverse-primary p-2 text-text-inverse-primary shadow-md">
      {t("tooltip_copied")}
      <span className="absolute -bottom-1 left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 bg-surface-inverse-primary" />
    </span>
  );
});
